<div class="main-content">

  <!-- ─── HEADER ─── -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--orange">
        <i class="fas fa-folder-plus"></i>
      </div>
      <div>
        <h1 class="main-title">Nuova Pratica Danno</h1>
        <p class="main-subtitle">
          Apertura pratica danno per il collo
          <span class="cd-parcel-code">{{ parcelCode }}</span>
        </p>
      </div>
    </div>
  </div>

  <!-- ─── UNICA SEZIONE: FORM PRATICA DANNO ─── -->
  <div class="card mb-4">
    <div class="card-header">
      <div class="header-title">
        <i class="fas fa-folder-plus header-icon"></i>
        <h3>Pratica Danno</h3>
      </div>
    </div>

    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="submit()">

        <!-- Riferimenti -->
        <h6 class="filter-group-title">
          <i class="fas fa-link me-1 text-warning"></i> Riferimenti
        </h6>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Codice Collo <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper disabled-input">
              <i class="fas fa-box filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageParcelCode">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">ID Collo</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-hashtag filter-icon"></i>
              <input type="number" class="filter-input" formControlName="damageParcelId"
                     placeholder="ID interno del collo">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Codice Bolla</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-barcode filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageWaybillCode"
                     placeholder="Codice bolla...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Codice Cliente</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-users filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageClientCode"
                     placeholder="Codice cliente...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Codice Brand</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-tag filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageBrandCode"
                     placeholder="Codice brand...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Codice Dealer</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-store filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageDealerCode"
                     placeholder="Codice dealer...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Codice Corriere</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-shipping-fast filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageCarrierCode"
                     placeholder="Codice corriere...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">ID Instradamento</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-route filter-icon"></i>
              <input type="number" class="filter-input" formControlName="damageTourRoutingId"
                     placeholder="ID instradamento...">
            </div>
          </div>
        </div>

        <!-- Classificazione -->
        <h6 class="filter-group-title mt-4">
          <i class="fas fa-tags me-1 text-warning"></i> Classificazione
        </h6>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Stato</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-flag filter-icon"></i>
              <select class="filter-select" formControlName="damageStatus">
                <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Tipo Danno <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper" [class.cd-invalid]="isFieldInvalid('damageType')">
              <i class="fas fa-hammer filter-icon"></i>
              <select class="filter-select" formControlName="damageType">
                <option value="" disabled>Seleziona il tipo...</option>
                <option *ngFor="let t of typeOptions" [value]="t">{{ t }}</option>
              </select>
            </div>
            <div class="cd-field-error" *ngIf="isFieldInvalid('damageType')">Il tipo danno è obbligatorio.</div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Severità <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper" [class.cd-invalid]="isFieldInvalid('damageSeverity')">
              <i class="fas fa-exclamation-circle filter-icon"></i>
              <select class="filter-select" formControlName="damageSeverity">
                <option value="" disabled>Seleziona la severità...</option>
                <option *ngFor="let s of severityOptions" [value]="s">{{ s }}</option>
              </select>
            </div>
            <div class="cd-field-error" *ngIf="isFieldInvalid('damageSeverity')">La severità è obbligatoria.</div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Priorità</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-sort-numeric-up filter-icon"></i>
              <select class="filter-select" formControlName="damagePriority">
                <option *ngFor="let p of priorityOptions" [ngValue]="p">{{ p }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Rilevamento -->
        <h6 class="filter-group-title mt-4">
          <i class="fas fa-search-location me-1 text-warning"></i> Rilevamento
        </h6>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Fase di Rilevamento <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper" [class.cd-invalid]="isFieldInvalid('damageDetectedPhase')">
              <i class="fas fa-map-signs filter-icon"></i>
              <select class="filter-select" formControlName="damageDetectedPhase">
                <option value="" disabled>Seleziona la fase...</option>
                <option *ngFor="let p of detectedPhaseOptions" [value]="p">{{ p }}</option>
              </select>
            </div>
            <div class="cd-field-error" *ngIf="isFieldInvalid('damageDetectedPhase')">La fase di rilevamento è obbligatoria.</div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Data/Ora Rilevamento</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-plus filter-icon"></i>
              <input #detectedAtInput type="text" class="filter-input" readonly
                     placeholder="Seleziona data e ora...">
              <div class="date-navigation-controls">
                <div class="date-nav-separator"></div>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageDetectedAt', -1)" title="Giorno precedente">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="setDateToday('damageDetectedAt')" title="Oggi">
                  <i class="fas fa-calendar-day"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageDetectedAt', 1)" title="Giorno successivo">
                  <i class="fas fa-chevron-right"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="clearDate('damageDetectedAt')" title="Cancella data">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Località Rilevamento</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-map-marker-alt filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageDetectedLocation"
                     placeholder="Località...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Rilevato Da</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-user filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageDetectedBy"
                     placeholder="Operatore...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Fonte Segnalazione <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper" [class.cd-invalid]="isFieldInvalid('damageSource')">
              <i class="fas fa-satellite-dish filter-icon"></i>
              <select class="filter-select" formControlName="damageSource">
                <option value="" disabled>Seleziona la fonte...</option>
                <option *ngFor="let s of sourceOptions" [value]="s">{{ s }}</option>
              </select>
            </div>
            <div class="cd-field-error" *ngIf="isFieldInvalid('damageSource')">La fonte segnalazione è obbligatoria.</div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Parte Responsabile</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-balance-scale filter-icon"></i>
              <select class="filter-select" formControlName="damageLiableParty">
                <option value="">-</option>
                <option *ngFor="let l of liablePartyOptions" [value]="l">{{ l }}</option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <label class="form-label">Descrizione del Danno <span class="text-danger">*</span></label>
            <div class="filter-input-wrapper filter-input-wrapper--textarea"
                 [class.cd-invalid]="isFieldInvalid('damageDescription')">
              <i class="fas fa-align-left filter-icon"></i>
              <textarea class="filter-input cd-textarea" rows="3" formControlName="damageDescription"
                        placeholder="Descrivi il danno riscontrato sul collo..."></textarea>
            </div>
            <div class="cd-field-error" *ngIf="isFieldInvalid('damageDescription')">La descrizione è obbligatoria.</div>
          </div>
        </div>

        <!-- Gestione -->
        <h6 class="filter-group-title mt-4">
          <i class="fas fa-user-cog me-1 text-warning"></i> Gestione
        </h6>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Assegnata A</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-user-cog filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageAssignedTo"
                     placeholder="Operatore assegnatario...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Scadenza</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-check filter-icon"></i>
              <input #dueDateInput type="text" class="filter-input" readonly
                     placeholder="Seleziona data e ora...">
              <div class="date-navigation-controls">
                <div class="date-nav-separator"></div>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageDueDate', -1)" title="Giorno precedente">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="setDateToday('damageDueDate')" title="Oggi">
                  <i class="fas fa-calendar-day"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageDueDate', 1)" title="Giorno successivo">
                  <i class="fas fa-chevron-right"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="clearDate('damageDueDate')" title="Cancella data">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Data Apertura</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-day filter-icon"></i>
              <input #openedAtInput type="text" class="filter-input" readonly
                     placeholder="Seleziona data e ora...">
              <div class="date-navigation-controls">
                <div class="date-nav-separator"></div>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageOpenedAt', -1)" title="Giorno precedente">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="setDateToday('damageOpenedAt')" title="Oggi">
                  <i class="fas fa-calendar-day"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageOpenedAt', 1)" title="Giorno successivo">
                  <i class="fas fa-chevron-right"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="clearDate('damageOpenedAt')" title="Cancella data">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Aperta Da</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-user filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageOpenedBy"
                     placeholder="Operatore...">
            </div>
          </div>
        </div>

        <!-- Chiusura -->
        <h6 class="filter-group-title mt-4">
          <i class="fas fa-check-circle me-1 text-warning"></i> Chiusura
        </h6>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Data Chiusura</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-calendar-minus filter-icon"></i>
              <input #closedAtInput type="text" class="filter-input" readonly
                     placeholder="Seleziona data e ora...">
              <div class="date-navigation-controls">
                <div class="date-nav-separator"></div>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageClosedAt', -1)" title="Giorno precedente">
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="setDateToday('damageClosedAt')" title="Oggi">
                  <i class="fas fa-calendar-day"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="adjustDate('damageClosedAt', 1)" title="Giorno successivo">
                  <i class="fas fa-chevron-right"></i>
                </button>
                <button type="button" class="date-nav-btn" (click)="clearDate('damageClosedAt')" title="Cancella data">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Chiusa Da</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-user-check filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageClosedBy"
                     placeholder="Operatore...">
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Esito Chiusura</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-clipboard-check filter-icon"></i>
              <select class="filter-select" formControlName="damageCloseOutcome">
                <option value="">-</option>
                <option *ngFor="let o of closeOutcomeOptions" [value]="o">{{ o }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label">Nota di Chiusura</label>
            <div class="filter-input-wrapper">
              <i class="fas fa-sticky-note filter-icon"></i>
              <input type="text" class="filter-input" formControlName="damageCloseNote"
                     placeholder="Nota...">
            </div>
          </div>
        </div>

        <!-- Azioni (come la card filtri di damage-management) -->
        <div class="mt-4 pt-3 border-top">
          <div class="d-flex justify-content-end align-items-center gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancel()" [disabled]="isSaving">
              <i class="fas fa-times me-1"></i> Annulla
            </button>
            <button type="submit" class="btn btn-primary btn-sm" [disabled]="isSaving">
              <i class="fas me-1" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
              Crea Pratica Danno
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>
